import React, { Component } from 'react';
import { translate } from 'react-i18next';
import request from 'superagent';
import {ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import moment from 'moment';

class NginxRequestChart extends Component {
    state = {
        data: [],
        loading: false,
        intervalId: 0
    };

    fetch = () => {
        this.setState({loading: true});
        request.get('/api/dashboard/nginx/metric')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    var data = response.body;
                    for (var i = 0; i < data.length; i++) {
                        var utcTime = moment(data[i].time).local();
                        data[i].time = utcTime.format("HH:00");
                        /*var utcTime = moment.utc().hours(data[i].time);
                        utcTime.local();
                        data[i].time = utcTime.hours() + ':00';*/
                    }
                    this.setState({
                        loading: false,
                        data: data
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    componentDidMount() {
        this.fetch();
        var intervalId = setInterval(this.fetch, 30*60*1000);
        this.setState({intervalId: intervalId});
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    render() {
        const data = this.state.data;
        return (
            <ResponsiveContainer width="100%" height={200}>
                <AreaChart width={600} height={200} data={data}
                           margin={{top: 0, right: 0, left: 0, bottom: 0}}>
                    <XAxis dataKey="time"/>
                    <YAxis/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip/>
                    <Legend verticalAlign="top" height={54} align="center" iconType="square"/>
                    {/*<ReferenceLine y={1000} label="Max" stroke="red" strokeDasharray="3 3" />*/}
                    <Area type='monotone' dataKey='nginx1' unit=" Requests" stackId="1" stroke='#fba53f' fill='#fba53f'/>
                    <Area type='monotone' dataKey='nginx2' unit=" Requests" stackId="1" stroke='#539a8e' fill='#539a8e'/>
                </AreaChart>
            </ResponsiveContainer>
        );
    }
}
export default translate()(NginxRequestChart);


// WEBPACK FOOTER //
// ./src/modules/dashboard/NginxRequestChart.js